var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C10.3256 16.9984 11.5965 16.4468 12.5339 15.4662C13.4712 14.4856 13.9985 13.156 14 11.7692V5.23077C14 3.84348 13.4732 2.51302 12.5355 1.53206C11.5979 0.551097 10.3261 0 9 0C7.67392 0 6.40215 0.551097 5.46447 1.53206C4.52678 2.51302 4 3.84348 4 5.23077V11.7692C4.00149 13.156 4.52875 14.4856 5.46611 15.4662C6.40347 16.4468 7.67437 16.9984 9 17ZM5.66667 5.23077C5.66667 4.30591 6.01786 3.41893 6.64298 2.76496C7.2681 2.11099 8.11594 1.74359 9 1.74359C9.88405 1.74359 10.7319 2.11099 11.357 2.76496C11.9821 3.41893 12.3333 4.30591 12.3333 5.23077V11.7692C12.3333 12.6941 11.9821 13.5811 11.357 14.235C10.7319 14.889 9.88405 15.2564 9 15.2564C8.11594 15.2564 7.2681 14.889 6.64298 14.235C6.01786 13.5811 5.66667 12.6941 5.66667 11.7692V5.23077Z",
    fill: "#001C35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 8V10.975C16.3636 15.1931 13.0602 18.625 9 18.625C4.93977 18.625 1.63636 15.1931 1.63636 10.975V8H0V10.975C0 15.8441 3.60123 19.8551 8.18182 20.286V25H9.81818V20.286C14.3988 19.8551 18 15.8441 18 10.975V8H16.3636Z",
    fill: "#001C35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.ea161d33.svg";
export { ForwardRef as ReactComponent };